import React, { useMemo, useState } from 'react';
import useItemTypes from '../../../Hooks/useItemTypes';
import AddBoxMenu from '../../../Components/AddBoxMenu/AddBoxMenu.component';
import OptionsMenu from '../../../Components/OptionsMenu';
import { useAuth } from '../../../Contexts/AuthProvider';
import { useBoxes } from '../../../Contexts/BoxContext';
import { userHasPermission } from '../../../helpers';
import UnitJobDateRangeGlobalFilters from '../../../Components/filters/UnitJobDateRangeGlobalFilters';
import DownloadFileButton from '../../../Components/DownloadFileButton';
import useTranslation from 'Hooks/useTranslation';
import { Button } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import MapComponentModal from 'Components/MapComponentModal';
import QuickAddTiles from 'Components/QuickAddTiles/QuickAddTiles.component';
import useAddBoxSelect from 'Hooks/useAddBoxSelect';
import FolderOpenOutlinedIcon from '@material-ui/icons/FolderOpenOutlined';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';

const LocationGroupHeader = props => {

    const {
        onAddBox,
        title,
        onLoadTemplate,
        onSaveTemplate,
        onExportCsv,
        onChangeUnit,
        unitsRequest,
        handleChangeUnit,
        showMapBtn,
        gpsData
    } = props;

    const { currentUser } = useAuth();
    const {
        locationBoxes: unitBoxes,
        currentLocationUnit: currentUnit,
        currentLocationUnitModel: currentUnitModel,
        isMainGroup,
        locationBoxesFilters: unitBoxesFilters,
        changeLocationGlobalFilters: changeUnitGlobalFilters,
        refreshBoxes,
        dataExportLocationsRequest,
        setModalStep
    } = useBoxes();
    const { data: itemTypes } = useItemTypes('units');
    const translation = useTranslation();
    const [isMapModalOpen, setIsMapModalOpen] = useState(false);

    const allowManageTemplate = useMemo(() => userHasPermission(currentUser, 'manage_templates'), [currentUser]);
    const selectBox = useAddBoxSelect(onAddBox);

    // the same actions as in the Options menu, shown as tiles on the empty dashboard
    const getQuickActions = () => {
        if (!isMainGroup) return [];

        const actions = [
            {
                id: 'quickAddTile-loadTemplate',
                icon: FolderOpenOutlinedIcon,
                group: 'options',
                label: translation.dashboardLoadTemplateLabel,
                onClick: onLoadTemplate,
            },
        ];
        if (currentUser.canExportCsv()) {
            actions.push({
                id: 'quickAddTile-exportCsv',
                icon: GetAppOutlinedIcon,
                group: 'options',
                label: translation.exportLocationToCsvLabel,
                onClick: () => {
                    onExportCsv();
                    setModalStep('jobOptionsCsv');
                },
            });
        }

        return actions;
    };

    const renderOptionsButton = () => {
        if (!isMainGroup) return null;

        return (
            <OptionsMenu
                refreshDisabled={!unitBoxes.length}
                onRefresh={() => refreshBoxes('locations')}
                isCurrentJobSet={!!currentUnit}
                allowManageTemplate={allowManageTemplate}
                disableSaveTemplate={!currentUnit && unitBoxes.length === 0}
                onLoadTemplate={onLoadTemplate}
                onSaveTemplate={onSaveTemplate}
                onExportCsv={onExportCsv}
                onChangeUnit={onChangeUnit}
                changeUnitDisabled={!currentUnit}
                exportCsvLabel={translation.exportLocationToCsvLabel}
            />
        );
    };

    const renderGlobalFilters = () => {
        if (!isMainGroup) return null;
        // if (!currentUnitModel) return null;


        return (
            <UnitJobDateRangeGlobalFilters
                tabType='locations'
                unitUid={currentUnitModel?.uId}
                inline
                onChange={changeUnitGlobalFilters}
                initData={unitBoxesFilters}
            />
        );
    };

    return (
      <>
        <div className="pageBtnSection">
          <div className="part">
            <div className="btnGroup">
              <div className="item">
                <AddBoxMenu itemTypes={itemTypes} onAddBox={onAddBox} />
              </div>
              <div className="item">{renderOptionsButton()}</div>
              <div className="item">
                <DownloadFileButton
                  getExportRequest={dataExportLocationsRequest}
                  tabType="locations" />
              </div>
            </div>
          </div>
          <div className="part centered centeredMobile">
            <div className="flex">
              <Button
                onClick={() => {
                  onChangeUnit();
                } }
                className="asideNavItem"
                fullWidth
                endIcon={<ArrowDropDownIcon />}
                id="asideMmsMenuChangeDepartmentBtn"
              >
                <span className="hasMaxWidth titleLimitSymbols">
                  {currentUnitModel ? currentUnitModel.name : "Select Location"}
                </span>
              </Button>
              {showMapBtn && currentUnitModel?.uId ? (
                <Button
                  onClick={() => {
                    setIsMapModalOpen(true);
                  } }
                  className="asideNavItem"
                  endIcon={<MyLocationIcon style={{ marginLeft: "-40px" }} />}
                >
                  {/* <span className="hasMaxWidth">View on Map</span> */}
                </Button>
              ) : null}
            </div>
          </div>
          <div className="part end">{renderGlobalFilters()}</div>
        </div>
        {!unitBoxes.length && (
          <QuickAddTiles
            itemTypes={itemTypes}
            onSelect={selectBox}
            actions={getQuickActions()}
          />
        )}
        <MapComponentModal currentUnitModel={currentUnitModel} isOpen={isMapModalOpen} onCancel={() => setIsMapModalOpen(false)} section="locations" gpsData={gpsData}/>
      </>
    );
};

export default LocationGroupHeader;
